var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m94.013 53.384-.002.005a38.17 38.17 0 0 1 8.331 23.861c0 9.154-3.21 17.56-8.565 24.152l-.461.567-.122-.721a34.22 34.22 0 0 0-.368-1.857C90.145 87.6 81.414 77.488 67.042 69.3c-9.705-5.514-15.26-12.153-16.718-19.696-.942-4.878-.242-9.778 1.112-13.974s3.366-7.71 5.075-9.826l5.592-6.847a2.45 2.45 0 0 1 3.796 0l28.115 34.428zm8.843-6.84L65.385.657a1.79 1.79 0 0 0-2.77 0L25.143 46.542l-.121.154A49.77 49.77 0 0 0 14 78.009C14 105.618 36.385 128 64 128s50-22.382 50-49.991a49.77 49.77 0 0 0-11.022-31.313l-.122-.152zm-68.747 6.692 3.353-4.106.101.758c.08.6.178 1.204.293 1.81 2.169 11.395 9.916 20.896 22.868 28.255 11.258 6.417 17.814 13.796 19.702 21.889.788 3.377.929 6.7.587 9.605l-.021.18-.163.079a38.195 38.195 0 0 1-16.831 3.882c-21.175 0-38.342-17.163-38.342-38.336 0-9.09 3.165-17.443 8.453-24.014z",
    fillRule: "evenodd",
    fill: "#4ca3ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.f0a5891dce03467e0b5bf08c2a9f4f05.svg";
export { ForwardRef as ReactComponent };